module.exports = "### 客户简介\r\n网易云会议是网易企业邮箱团队推出的一款基于云计算技术的高效、便捷、实惠的视频会议产品，借助云会议，机构可降低费用成本、提高沟通效率。用户仅需联网电脑，即可快速召开、接入视频会议，无需专用硬件设备，不受地域限制影响。"